/* tslint:disable */
/* eslint-disable */
import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiConfiguration, ApiConfigurationParams } from './api-configuration';

import { MyAsiBillableServiceSystemInfoControllerService } from './services/my-asi-billable-service-system-info-controller.service';

/**
 * Module that provides all services and configuration.
 */
@NgModule({
  imports: [],
  exports: [],
  declarations: [],
  providers: [
    MyAsiBillableServiceSystemInfoControllerService,
    ApiConfiguration
  ],
})
export class BillableServiceSysteminfoModule {
  static forRoot(params: ApiConfigurationParams): ModuleWithProviders<BillableServiceSysteminfoModule> {
    return {
      ngModule: BillableServiceSysteminfoModule,
      providers: [
        {
          provide: ApiConfiguration,
          useValue: params
        }
      ]
    }
  }

  constructor( 
    @Optional() @SkipSelf() parentModule: BillableServiceSysteminfoModule,
    @Optional() http: HttpClient
  ) {
    if (parentModule) {
      throw new Error('BillableServiceSysteminfoModule is already loaded. Import in your base AppModule only.');
    }
    if (!http) {
      throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
      'See also https://github.com/angular/angular/issues/20575');
    }
  }
}
